// plugins/accessibility-mode.client.js
// Adds 'accessibility-on' class to <body> or <html> when user presses Tab, removes on mouse movement

export default function () {
  // Use body for class toggling (can be changed to document.documentElement for <html>)
  const target = document.body;
  let accessibilityOn = false;

  function handleTab(e) {
    if (e.key === 'Tab') {
      if (!accessibilityOn) {
        target.classList.add('accessibility-on');
        accessibilityOn = true;
      }
    }
  }

  function handleMouse() {
    if (accessibilityOn) {
      target.classList.remove('accessibility-on');
      accessibilityOn = false;
    }
  }

  // Attach listeners on client only
  if (process.client || typeof window !== 'undefined') {
    window.addEventListener('keydown', handleTab, true);
    window.addEventListener('mousemove', handleMouse, true);
    window.addEventListener('mousedown', handleMouse, true);
    window.addEventListener('touchstart', handleMouse, true);
  }
}
